/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
( ( FUNCTIONS ) => {
	const a = 'is-active';
	const v = 'is-visible';

	const quality02Swiper = () => {
		const swiper = new Swiper( ".sustainability-social-quality02-swiper", {
			slidesPerView: 1,
			loop: true,
			speed: 2000,
			// autoplay: {
			// 	delay: 3000,
			// },
			pagination: {
				el: ".sustainability-social-quality02-swiper-pagination-pagination"
			},
			navigation: {
				nextEl: ".sustainability-social-quality02-swiper-pagination-button-next",
				prevEl: ".sustainability-social-quality02-swiper-pagination-button-prev"
			}
		} );
	}
	quality02Swiper();


} )( window.FUNCTIONS );
